import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const Popup = ({ lang }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          ¡Hoy es el primer Día de Acción de la Salud Mental!
        </Modal.Title>
      </Modal.Header>
      <Modal.Body closeButton>
        Desde apoyar a un amigo hasta explorar recursos, tomar medidas sobre la
        salud mental puede ser fácil. Mental Health is Health es un sitio de
        recursos único para ayudarte a tomar medidas para ti, tus seres queridos
        y tu comunidad.
      </Modal.Body>
      <Modal.Footer>
        <a
          href="https://www.mentalhealthishealth.us/"
          className="btn btn-white btn-block"
          target="_blank"
          rel="noreferrer"
        >
          Encuentre recursos
        </a>
      </Modal.Footer>
    </Modal>
  );
};
export default Popup;
